/**
 * CreateCycleDialog — the one create-cycle form (CreateCycleForm, owner ruling
 * #7) in the design-system Modal, for desktop hosts (cycles list, admin
 * planning objects). The phone list puts the same form in its BottomSheet.
 */
import { Modal } from '@/components/ds';
import { CreateCycleForm, type CreateCycleFormProps } from './CreateCycleForm';
import { CREATE_CYCLE_DIALOG_TITLE } from '@/lib/cycles/vocabulary';

export interface CreateCycleDialogProps extends Omit<CreateCycleFormProps, 'onCancel'> {
  open: boolean;
  onClose: () => void;
}

export function CreateCycleDialog({ open, onClose, ...formProps }: CreateCycleDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      label="New cycle"
      title={CREATE_CYCLE_DIALOG_TITLE}
      description="Name it and set its scope — you'll design the ball paths next."
      size="lg"
    >
      {open && <CreateCycleForm onCancel={onClose} {...formProps} />}
    </Modal>
  );
}
